import React, { useEffect, Fragment } from 'react';

import { makeStyles } from "@material-ui/core/styles";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import LinearProgress from '@material-ui/core/LinearProgress';

import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import AddCircleIcon from '@material-ui/icons/AddCircle';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';


const useStyles = makeStyles(theme => ({
    card: {
        backgroundColor: "rgba(226, 237, 255, 0.4)",
        marginBottom: 10,
        '&:hover': {
            backgroundColor: "rgba(23, 99, 162, 0.18) !important",
        }
    },
    cardTitle: {
        '&:hover': {
            cursor: "pointer",
        }
    },
    cardSelected: {
        backgroundColor: "rgba(23, 99, 162, 0.18) !important"
    },
    paper: {
        padding: theme.spacing(3),
    },
    row: {
        width: '100%',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        '& svg': {
            margin: theme.spacing(1.5),
        },
        '& hr': {
            margin: theme.spacing(0, 0.5),
        },
        '& p' : {
            padding: theme.spacing(2),
        },
        '& .MuiButton-outlined': {
            margin: theme.spacing(0, 1),
        }
    },
    form: {
        maxWidth: 500,
        width: '100%',
        '& .MuiTextField-root': {
            background: '#ffffff',
        },
        marginBottom: 10
    },
    itemsForm: {
        '& .MuiTextField-root': {
            background: '#ffffff',
        },
        marginBottom: 10
    },
    numberField: {
        maxWidth: 95,
    },
    sectionSubComponentWrapper: {
        marginBottom: 25,
        background: '#f8fafc',
        border: `1px solid ${theme.palette.divider}`,
        marginTop: -12,
        padding: theme.spacing(1.5, 1.5)
    },
    addItemButton: {
        '&:hover': {
            cursor: "pointer",
        }
    },
    minInputWidth: {
        minWidth: 100
    },
    addItemStatus: {
        marginTop: -24,
        '& .MuiFormControlLabel-root': {
            paddingTop: 18
        }
    }
}));


const CeremonySection = (props) => {
    const {
        section,
        categories
    } = props;

    const classes = useStyles();

    const [state, setState] = React.useState({
        selected: false,
        component: 'details',
        sectionName: section.section_name,
    });

    const toggleSelected = component => () => {
        let newSelected;
        if (state.component !== component && state.selected === true) {
            newSelected = state.selected;
        } else {
            newSelected = !state.selected;
        }
        setState({
            ...state,
            selected: newSelected,
            component
        })
    }

    const [detailsState, setDetailsState] = React.useState({
        name: section.section_name,
        order: section.section_order,
        instruction: section.section_instruction,
        default: section.section_default
    });

    const [snackbar, setSnackbar] = React.useState({
        open: false,
        message: '',
    });

    const handleCloseSnackbar = () => {
        setSnackbar({
            ...snackbar,
            open: false,
        })
    }

    const handleSaveClick = () => {
        const formData = {
            ...detailsState,
            _token: window._token
        };
        const url = `/api/admin/ceremony/templates/sections/${section.section_id}`;
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            return response.json();
        })
        .then(result => {
            setSnackbar({
                message: "Saved section",
                open: true
            });
            setState({
                ...state,
                sectionName: result.section_name
            });
        })
        .catch(reason => {
            alert('Please try again');
        })
    }

    const handleSaveItemsClick = () => {
        setSnackbar({
            message: "Saved section item",
            open: true
        })
    }

    return (
        <Fragment>
            <div className={`${classes.card} ${state.selected ? classes.cardSelected : ''}`}>
                <Grid container alignItems="center" className={classes.row}>
                    <Box flexGrow={1}>
                        <Typography onClick={toggleSelected('items')} className={classes.cardTitle}>
                            {section.section_id === 27 ? (state.sectionName + " (DEPRECATED)" ) : state.sectionName}
                        </Typography>
                    </Box>
                    <Button onClick={toggleSelected('items')} color="primary"  variant="outlined">
                        Edit Items
                    </Button>
                    <Divider orientation="vertical" flexItem />
                    <Button onClick={toggleSelected('details')} variant="outlined">
                        Edit Details
                    </Button>
                </Grid>
            </div>
            {state.selected && state.component === 'items' && (
                <EditSectionItems
                    section={section}
                    categories={categories}
                    handleSaveItemsClick={handleSaveItemsClick}
                    toggleSelected={toggleSelected('items')}
                />
            )}
            {state.selected && state.component === 'details' && (
                <EditDetailsForm
                    detailsState={detailsState}
                    setDetailsState={setDetailsState}
                    handleSaveClick={handleSaveClick}
                    toggleSelected={toggleSelected('details')}
                />
            )}
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        </Fragment>
    )
}

const EditDetailsForm = (props) => {
    const classes = useStyles();

    const {
        detailsState,
        setDetailsState,
        handleSaveClick,
        toggleSelected
    } = props;

    const handleChange = name => event => {
        const value = event.target.value;
        setDetailsState({
            ...detailsState,
            [name]: value,
        })
    }

    /* TODO: add checkbox for Active/Inactive */

    return (
        <div className={classes.sectionSubComponentWrapper}>
            <p>Edit Details</p>
            <form className={classes.form}>
                <TextField
                    fullWidth
                    margin="dense"
                    label="Title"
                    value={detailsState.name || ''}
                    onChange={handleChange('name')}
                    variant="outlined"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextField
                    fullWidth
                    margin="dense"
                    label="Order"
                    type="number"
                    value={detailsState.order}
                    onChange={handleChange('order')}
                    variant="outlined"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    className={classes.numberField}
                />
                <TextField
                    fullWidth
                    margin="dense"
                    label="Instruction"
                    value={detailsState.instruction || ''}
                    onChange={handleChange('instruction')}
                    variant="outlined"
                    multiline
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextField
                    fullWidth
                    margin="dense"
                    label="Section Default"
                    value={detailsState.default || ''}
                    onChange={handleChange('default')}
                    variant="outlined"
                    multiline
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </form>
            <Button variant="contained" color="primary" onClick={handleSaveClick}>
                Save
            </Button>
            <Box ml={2} display="inline-block">
                <Button onClick={toggleSelected}>
                    Close
                </Button>
            </Box>
        </div>
    )
}

const SectionItem = (props) => {
    const classes = useStyles();

    const {
        item,
        categories,
        handleSaveItemsClick
    } = props;

    const _defaultState = (data) => {
        return {
            item_order: data.item_order,
            item_name: data.item_name,
            item_category_id: data.item_category_id,
            item_text: data.item_text,
            item_status: data.item_status,
            modified: false
        }
    }

    const defaultState = _defaultState(item);

    const [state, setState] = React.useState(defaultState);
    const [oldState, setOldState] = React.useState(defaultState);

    const resetItem = () => {
        setState(oldState);
    }

    const handleChange = name => event => {
        let value;
        if (name == 'item_status') {
            value = event.target.checked ? 'Active' : 'Inactive';
        } else {
            value = event.target.value;
        }
        setState({
            ...state,
            [name]: value,
            modified: true
        })
    }

    const handleSaveClick = () => {
        const formData = {
            ...state,
            _token: window._token
        };
        const url = `/api/admin/ceremony/templates/items/${item.item_id}`;
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            return response.json();
        })
        .then(result => {
            handleSaveItemsClick();
            setOldState(_defaultState(result));
            setState({
                ...state,
                modified: false
            });
        })
        .catch(reason => {
            alert('Please try again');
        })
    }

    return (
        <Fragment>
            <Grid container spacing={1}>
                <Grid item xs={1}>
                    <TextField
                        fullWidth
                        margin="dense"
                        label="Order"
                        type="number"
                        value={state.item_order}
                        onChange={handleChange('item_order')}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        className={classes.numberField}
                    />
                </Grid>
                <Grid item xs={9}>
                    <TextField
                        fullWidth
                        margin="dense"
                        label="Name"
                        value={state.item_name}
                        onChange={handleChange('item_name')}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={1}></Grid>
                <Grid item xs={9}>
                    <TextField
                        fullWidth
                        margin="dense"
                        label="Text"
                        value={state.item_text}
                        onChange={handleChange('item_text')}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        multiline
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={1}></Grid>
                <Grid item xs={9}>
                    <TextField
                        select
                        margin="dense"
                        label="Category"
                        value={state.item_category_id}
                        onChange={handleChange('item_category_id')}
                        variant="outlined"
                        SelectProps={{
                            autoWidth: true
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        className={classes.minInputWidth}
                    >
                        <MenuItem key='item-category-0' value={0}>
                            ---
                        </MenuItem>
                        {categories.map(option => (
                            <MenuItem key={`item-category-${option.category_id}`} value={option.category_id}>
                                {option.category_name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <Box ml={2} display="inline-block">
                        <FormControlLabel
                            control={
                            <Checkbox
                                checked={state.item_status == 'Active'}
                                onChange={handleChange('item_status')}
                                name="item_status"
                                color="primary"
                            />
                            }
                            label="Active"
                        />
                    </Box>
                </Grid>
            </Grid>
            {state.modified && (
                <Box mb={1}>
                    <Grid container spacing={1}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={9}>
                            <Button variant="contained" color="primary" onClick={handleSaveClick}>Save</Button>
                            <Box ml={2} display="inline-block">
                                <Button onClick={resetItem}>
                                    Reset
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            )}
        </Fragment>
    )
}

const EditSectionItems = (props) => {
    const classes = useStyles();

    const {
        section,
        categories,
        handleSaveItemsClick,
        toggleSelected
    } = props;

    const [state, setState] = React.useState({
        items: [],
        loading: true,
    });

    React.useEffect(() => {
        const url = `/api/ceremony/templates/sections/${section.section_id}?status=All`;
        fetch(url)
            .then(response => {
                return response.json();
            })
            .then(result => {
                setTimeout(() => {
                    setState({
                        loading: false,
                        items: result
                    })
                }, 700)
            })
    }, [section.section_id]);

    return (
        <div className={classes.sectionSubComponentWrapper}>
            <p>Edit Items</p>
            {state.loading && <LinearProgress />}
            {!state.loading && (
                <Fragment>
                    {state.items.length === 0 && <p>No items yet</p>}
                    <form className={classes.itemsForm}>
                        {state.items.map(item => {
                            return (
                                <SectionItem
                                    key={`item-${item.item_id}`}
                                    item={item}
                                    categories={categories}
                                    handleSaveItemsClick={handleSaveItemsClick}
                                />
                            )
                        })}
                    </form>
                </Fragment>
            )}
            <Box ml={2} display="inline-block">
                <Button onClick={toggleSelected}>
                    Close
                </Button>
            </Box>
        </div>
    )
}


const SectionsList = (props) => {
    const {
        sections,
        categories
    } = props;

    return (
        <Fragment>
            {sections.map((section, id) => {
                const sectionId = `section-${id}`;
                return (
                    <CeremonySection key={sectionId} section={section} categories={categories} />
                )
            })}
        </Fragment>
    )
}

const AddItemForm = (props) => {
    const {
        closeAddItemForm,
        categories,
        sections,
        setSnackbar
    } = props;

    const [state, setState] = React.useState({
        item_name: '',
        item_text: '',
        item_order: '',
        item_category_id: 0,
        item_section_id: '',
        item_status: 'Active',
        disabled: true
    });

    const classes = useStyles();

    const handleChange = name => event => {
        let value;
        if (name == 'item_status') {
            value = event.target.checked ? 'Active' : 'Inactive';
        } else {
            value = event.target.value;
        }
        state[name] = value;
        let disabled = true;
        if (state.item_name && state.item_text && state.item_section_id !== '') {
            disabled = false;
        }
        setState({
            ...state,
            [name]: value,
            disabled
        })
    }

    const handleSaveClick = () => {
        if (!state.disabled) {
            const formData = {
                ...state,
                _token: window._token
            };
            const url = '/api/admin/ceremony/templates/items';
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                return response.json();
            })
            .then(result => {
                setSnackbar({
                    open: true,
                    message: 'Added item'
                })
                closeAddItemForm();
            })
            .catch(reason => {
                alert('Please try again');
            })
        }
    }

    return (
        <div>
            <Dialog open onClose={closeAddItemForm} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add Item</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Create a ceremony section suggestion.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="item_name"
                        label="Name"
                        value={state.item_name}
                        onChange={handleChange('item_name')}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        required
                        margin="dense"
                        id="item_text"
                        label="Text"
                        value={state.item_text}
                        onChange={handleChange('item_text')}
                        fullWidth
                        multiline
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <Box display="inline-block">
                        <TextField
                            required
                            select
                            margin="dense"
                            label="Section"
                            value={state.item_section_id}
                            onChange={handleChange('item_section_id')}
                            SelectProps={{
                                autoWidth: true
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            className={classes.minInputWidth}
                        >
                            <MenuItem key='item-section-blank' value="">
                                -- Select One --
                            </MenuItem>
                            {sections.map(option => (
                                <MenuItem key={`item-section-${option.section_id}`} value={option.section_id}>
                                    {option.section_id === 27 ? (option.section_name + " (DEPRECATED)" ) : option.section_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Box>
                    <Box ml={2} display="inline-block">
                        <TextField
                            required
                            select
                            margin="dense"
                            label="Category"
                            value={state.item_category_id}
                            onChange={handleChange('item_category_id')}
                            SelectProps={{
                                autoWidth: true
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            className={classes.minInputWidth}
                        >
                            <MenuItem key='item-category-0' value={0}>
                                ---
                            </MenuItem>
                            {categories.map(option => (
                                <MenuItem key={`item-category-${option.category_id}`} value={option.category_id}>
                                    {option.category_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Box>
                    <Box ml={2} display="inline-block">
                        <div className={classes.addItemStatus}>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.item_status == 'Active'}
                                    onChange={handleChange('item_status')}
                                    name="item_status"
                                    color="primary"
                                />
                                }
                                label="Active"
                            />
                        </div>
                    </Box>
                    <Box>
                        <TextField
                            margin="dense"
                            id="item_order"
                            label="Order"
                            value={state.item_order}
                            onChange={handleChange('item_order')}
                            helperText="Leave blank to add at end of section"
                            type="number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeAddItemForm} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleSaveClick} color="primary" disabled={state.disabled}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

const CeremonyTemplatesHome = (props) => {
    const classes = useStyles();

    const [state, setState] = React.useState({
        sections: [],
        categories: [],
        loading: true
    });

    useEffect(() => {
        document.title = `Ceremony Templates - Enduring Promises`;

        const url = '/api/ceremony/templates/sections?status=All';
        fetch(url)
            .then(response => {
                return response.json();
            })
            .then(sections => {
                const url = '/api/ceremony/templates/categories?status=All';
                fetch(url)
                    .then(response => {
                        return response.json();
                    })
                    .then(result => {
                        setState({
                            ...state,
                            sections,
                            categories: result,
                            loading: false,
                        })
                    })
            })
    }, [0]);

    const [addFormOpen, setAddFormOpen] = React.useState(false);

    const showAddItemForm = () => {
        setAddFormOpen(true);
    };

    const closeAddItemForm = () => {
        setAddFormOpen(false);
    };

    const [snackbar, setSnackbar] = React.useState({
        open: false,
        message: '',
    });

    const handleCloseSnackbar = () => {
        setSnackbar({
            ...snackbar,
            open: false,
        })
    }

    return (
        <Paper square className={classes.paper}>
            <Box mb={2} display="flex">
                <Box flexGrow={1}>
                    <Typography variant="h6">Ceremony Sections</Typography>
                </Box>
                <Box className={classes.addItemButton} onClick={showAddItemForm}>
                    <Button color="primary" endIcon={<AddCircleIcon />}>Add Item</Button>
                </Box>
            </Box>
            {addFormOpen && state.sections.length > 0 && state.categories.length > 0 && (
                <AddItemForm
                    closeAddItemForm={closeAddItemForm}
                    sections={state.sections}
                    categories={state.categories}
                    setSnackbar={setSnackbar}
                />
            )}
            {!state.loading && state.sections.length > 0 && state.categories.length > 0 && <SectionsList sections={state.sections} categories={state.categories} />}
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        </Paper>
    )
}

export default CeremonyTemplatesHome;
